import { Alert, Box, FormHelperText } from '@mui/material'
import CardActions from 'src/pages/sistema/components/CardActions'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { useLoadOptions } from 'src/hooks/useLoadOptions'
import { OperacionAFOCLFields, OperacionAFOCLTablaValorFields } from '../types/fields'
import { FormOperacionAFOCL } from '../types/types'
import { useAFOCLTablaValorInicial } from '../hooks/useTablaValorAFOCL'
import { useAFOPUAforoTipos } from '../../afopu/hooks/useAFOPUCache'
import AFOCLTablaValoresEditorGrid from './AFOCLTablaValoresEditorGrid '

interface SeccionNuevoAFOCLTablaValoresProps {
  formMethods: UseFormReturn<FormOperacionAFOCL>
  codSistemaPrincipal: number
}

const SeccionNuevoAFOCLTablaValores = ({ formMethods, codSistemaPrincipal }: SeccionNuevoAFOCLTablaValoresProps) => {
  const watchedUnidadNegocio = useWatch({ control: formMethods.control, name: OperacionAFOCLFields.CodUnidadNegocio });
  const watchedSectorComercial = useWatch({ control: formMethods.control, name: OperacionAFOCLFields.CodSectorComercial });

  // Hook de datos iniciales
  const { headers, rows, aforos, isLoading } = useAFOCLTablaValorInicial(watchedUnidadNegocio, watchedSectorComercial);

  // Efecto para cargar el formulario cuando llegan los datos del endpoint "inicial"
  useEffect(() => {
    if (aforos && aforos.length > 0) {
      const dataParaFormulario = aforos.map((item: any) => ({
        [OperacionAFOCLTablaValorFields.CodInstrumento]: item[OperacionAFOCLTablaValorFields.CodInstrumento],
        [OperacionAFOCLTablaValorFields.DescInstrumento]: item[OperacionAFOCLTablaValorFields.DescInstrumento],
        [OperacionAFOCLTablaValorFields.CodOperacionTipo]: item[OperacionAFOCLTablaValorFields.CodOperacionTipo],
        [OperacionAFOCLTablaValorFields.DescOperacionTipo]: item[OperacionAFOCLTablaValorFields.DescOperacionTipo],
        [OperacionAFOCLTablaValorFields.ValorCliente]: item[OperacionAFOCLTablaValorFields.ValorCliente],
        [OperacionAFOCLTablaValorFields.ValorPuente]: item[OperacionAFOCLTablaValorFields.ValorPuente],
        [OperacionAFOCLTablaValorFields.OrdenInstrumento]: item.ordenInstrumento ?? 0,
      }));
      formMethods.setValue(OperacionAFOCLFields.TablaValores, dataParaFormulario);
    }
  }, [aforos, formMethods]);

  return (
    <CardActions title='Tabla de Valores' icon='mdi:table-edit' colapsable tableContent>
      {!(watchedUnidadNegocio && watchedSectorComercial) ? (
        <Box sx={{ px: 4, py: 3 }}>
          <Alert severity={'info'}>Seleccione Unidad de Negocio y Sector comercial para cargar valores.</Alert>
        </Box>
      ) : (
        <AFOCLTablaValoresEditorGrid 
          formMethods={formMethods}
          headers={headers}
          rows={rows}
          aforos={aforos || []}
          isLoading={isLoading}
          codPais={codSistemaPrincipal}
        />
      )}
      
      {formMethods.formState.errors.tablaValores?.message && (
        <Box sx={{ px: 4 }}>
          <FormHelperText error>{formMethods.formState.errors.tablaValores.message}</FormHelperText>
        </Box>
      )}
    </CardActions>
  );
}

export default SeccionNuevoAFOCLTablaValores;